import type { SchemaProps } from "./Schema.d";

const Schema = ({ schema }: SchemaProps) =>
  schema ? (
    // eslint-disable-next-line react/no-danger
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schema }} />
  ) : null;

export default Schema;
